import { LAYOUT_TYPE, LAYOUT_TYPE_VALUE } from '@typings/setting/layoutType';
import {
  MENU_TEXT_TYPE,
  MENU_TEXT_TYPE_VALUE,
} from '@typings/menu/menuTextType';
import {
  MENU_DESIGN_TYPE,
  MENU_DESIGN_TYPE_VALUE,
} from '@typings/menu/menuType';
import { Iparticle } from '@typings/setting/particle.interface';
import { PARTICLE_DIR } from '@typings/setting/particleDirectionType';
import { atom, DefaultValue } from 'recoil';
import { LAYOUT_DIR, LAYOUT_DIR_VALUE } from '@typings/setting/layoutDir';
import { SUB_MENU_DIRECTION, SUB_MENU_DIRECTION_VALUE, SUB_MENU_FLEX_DIRECTION, SUB_MENU_FLEX_DIRECTION_VALUE } from '@typings/menu/subMenuDirectionType';

export const layoutTypeState = atom<LAYOUT_TYPE_VALUE>({
  key: 'layoutTypeState',
  default: LAYOUT_TYPE.TOP,
});

export const layoutTypeInitialState = atom<LAYOUT_TYPE_VALUE>({
  key: 'layoutTypeInitialState',
  default: LAYOUT_TYPE.LEFT, // 앱 초기 진입 상태
});

export const layoutTypeBackupState = atom<LAYOUT_TYPE_VALUE>({
  key: 'layoutTypeBackupState',
  default: LAYOUT_TYPE.UNSET,
});

export const layoutDirState = atom<LAYOUT_DIR_VALUE>({
  key: 'layoutDirState',
  default: LAYOUT_DIR.LEFT,
});

export const layoutPaddingState = atom<string>({
  key: 'layoutPaddingState',
  default: '',
});

export const logoTypeState = atom<string | undefined>({
  key: 'logoTypeState',
  default: '',
});

export const menuTypeState = atom<MENU_DESIGN_TYPE_VALUE>({
  key: 'menuTypeState',
  default: MENU_DESIGN_TYPE.COLOR,
});

export const menuTextTypeState = atom<MENU_TEXT_TYPE_VALUE>({
  key: 'menuTextTypeState',
  default: MENU_TEXT_TYPE.LEFT,
});

export const subMenuDirectionState = atom<SUB_MENU_DIRECTION_VALUE>({
  key: 'subMenuDirectionState',
  default: SUB_MENU_DIRECTION.TOPRIGHT,
});

export const subMenuFlexDirectionState = atom<SUB_MENU_FLEX_DIRECTION_VALUE>({
  key: 'subMenuFlexDirectionState',
  default: SUB_MENU_FLEX_DIRECTION.ROW,
});

export const menuHeightState = atom<string>({
  key: 'menuHeightState',
  default: '80px',
});

export const menuWidthState = atom<string>({
  key: 'menuWidthState',
  default: '220px',
});

export const layoutWidthState = atom<string>({
  key: 'layoutWidthState',
  default: '100%',
});
export const menuFixedState = atom<boolean>({
  key: 'menuFixedState',
  default: false,
});
export const showSideState = atom<boolean>({
  key: 'showSideState',
  default: false,
});

export const showBlogSlideState = atom<boolean>({
  key: 'showBlogSlideState',
  default: true,
});

export const iconDirectionState = atom<'row' | 'column'>({
  key: 'iconDirectionState',
  default: 'column',
});

export const topNavSideSeparatedState = atom<boolean>({
  key: 'topNavSideSeparatedState',
  default: true,
});

export const particleEffectOptionsState = atom<Iparticle>({
  key: 'particleEffectOptionsState',
  default: {
    color: '#fff',
    number: 20,
    size: 1.5,
    shapeImageURL: '',
    direction: PARTICLE_DIR.TOP_RIGHT,
    speed: 2,
  },
});

export const shootingStarColorState = atom<string>({
  key: 'shootingStarColorState',
  default: '#fff',
});

// localStorage key for gate page persistence
const GATE_PAGE_STORAGE_KEY = 'moogong_gate_page_passed';

// localStorage persistence effect
const localStorageEffect =
  (key: string) =>
  ({ setSelf, onSet }: { setSelf: any; onSet: any }) => {
    // 초기화 시 localStorage에서 값 읽기
    if (typeof window !== 'undefined') {
      const savedValue = localStorage.getItem(key);
      if (savedValue !== null) {
        // 저장된 값이 'true'면 대문 페이지를 이미 통과한 것 -> gatePageActive = false
        const hasPassed = savedValue === 'true';
        setSelf(!hasPassed); // 통과했으면 false, 아니면 true
      }
    }

    // 상태 변경 시 localStorage에 저장
    onSet((newValue) => {
      if (typeof window !== 'undefined') {
        if (newValue instanceof DefaultValue) {
          localStorage.removeItem(key);
        } else {
          // gatePageActive가 false가 되면 (통과했으면) 'true' 저장
          localStorage.setItem(key, (!newValue).toString());
        }
      }
    });
  };

export const gatePageActiveState = atom<boolean>({
  key: 'gatePageActiveState',
  default: true,
  effects_UNSTABLE: [localStorageEffect(GATE_PAGE_STORAGE_KEY)],
});
